import moment from "moment";
import React, { useEffect, useState } from "react";
import { ImNewTab } from "react-icons/im";
import { LuArchiveRestore } from "react-icons/lu";
import { MdInfoOutline } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Spinner, UncontrolledDropdown } from "reactstrap";
import Swal from "sweetalert2";
import PlaceholderImg from "../../assets/placeholder-img.png";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import ErrorComponent from "../../components/error/ErrorComponent";
import DotPagination from "../../components/pagination/DotPaginate";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { getcity } from "../../redux/Apislices/citySlice";
import {
  duplicateDevelopment,
  editDevelopment,
  getDevelopmentList,
  handleAddDevelopment,
  handleDevAddReset,
  permanentDeleteDevelopment,
  permanentDeleteMultipleDevelopment,
  restoreDevelopment,
  restoreMultipleDevelopment,
  temperoryDeleteDevelopment,
  temperoryDeleteMultipleDevelopment,
} from "../../redux/Apislices/developmentSlice";
import { getHomeType } from "../../redux/Apislices/homeTypeSlice";
import { getneighbourhood, getneighbourhoodByCity } from "../../redux/Apislices/neighbourhoodSlice";
import { getSaleStatus } from "../../redux/Apislices/saleStatusSlice";
import { USDollar, getScreenWidth } from "../../utils/Utils";
import { productData } from "../pre-built/products/ProductData";
import { filterRole, filterStatus } from "../pre-built/user-manage/UserData";
import styles from "./development.module.scss";

const statusOptions = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "draft", label: "Draft" },
  { value: "on hold", label: "On Hold" },
];

const itemsPerPageOptions = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const Development = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { development, saleStatusData, cityData, neighbourhoodData, homeTypeData, permission } = useSelector(
    (state) => ({
      development: state?.development,
      saleStatusData: state?.saleStatus,
      cityData: state?.city,
      neighbourhoodData: state?.neighbourhood,
      homeTypeData: state?.homeType,
      permission: state?.auth?.profile?.permissions?.development,
    })
  );

  const [selectedData, setSelectedData] = useState([]);
  const [screenWidth, setScreenWidth] = useState(getScreenWidth());
  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);

  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");

  const [limit, setLimit] = useState({ value: 25, label: "25" });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);

  const [sort, setSort] = useState("");
  const [status, setStatus] = useState(null);
  const [saleStatus, setSaleStatus] = useState(null);
  const [homeType, setHomeType] = useState(null);
  const [city, setCity] = useState(null);
  const [neighbourhood, setNeighbourhood] = useState(null);
  const [developer, setDeveloper] = useState(null);

  //debounce getDevelopmentList for search
  useEffect(() => {
    const timer = setTimeout(
      () => {
        dispatch(
          getDevelopmentList({
            status: typeof status === "object" ? status?.value : status,
            saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
            page: currentPage,
            limit: itemPerPage,
            search: onSearchText,
            sort,
            homeType: typeof homeType === "object" ? homeType?.value : "",
            city: typeof city === "object" ? city?.value : "",
            neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
            developer: typeof developer === "object" ? developer?.value : "",
          })
        );
      },
      onSearchText ? 800 : 200
    );
    return () => clearTimeout(timer);
  }, [dispatch, currentPage, itemPerPage, onSearchText, sort, status, saleStatus, city, neighbourhood, developer]);

  useEffect(() => {
    if (typeof limit === "object" && limit?.value) setItemPerPage(limit?.value);
    else setItemPerPage(25);
  }, [limit]);

  useEffect(() => {
    dispatch(getSaleStatus());
    dispatch(getHomeType());
    dispatch(getcity());
  }, []);

  useEffect(() => {
    if (typeof city === "object" && city?.value) dispatch(getneighbourhoodByCity(city?.value));
    else dispatch(getneighbourhood());
  }, [city]);

  // selects all the products
  const selectorCheck = (e) => {
    // add or remove all the items from development?.development?.data to selectedData
    if (e.currentTarget.checked) {
      setSelectedData(development?.developments?.data?.map((item) => item._id));
    } else {
      setSelectedData([]);
    }
  };

  // selects one product
  const onSelectChange = (e, id) => {
    // add or remove the selected item from selectedData
    if (e.currentTarget.checked) {
      setSelectedData([...selectedData, id]);
    } else {
      setSelectedData(selectedData.filter((item) => item !== id));
    }
  };

  // toggle search input
  const toggle = () => setonSearch(!onSearch);

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleActiveDevelopment = (data) => {
    let payload = {
      ...data,
      type: data?.type,
    };

    if (data?.status === "active") payload.status = "on hold";
    else if (data?.status === "on hold" || data?.status === "pending") payload.status = "active";

    if (data?.status === "pending") payload = { ...payload, publishDate: moment(new Date(), "YYYY/MM/DD") };

    dispatch(
      editDevelopment(
        data?.slug,
        payload,
        (res) => {
          dispatch(
            getDevelopmentList({
              status: typeof status === "object" ? status?.value : status,
              saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
              page: currentPage,
              limit: itemPerPage,
              search: onSearchText,
              sort,
              homeType: typeof homeType === "object" ? homeType?.value : "",
              city: typeof city === "object" ? city?.value : "",
              neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
              developer: typeof developer === "object" ? developer?.value : "",
            })
          );
        },
        (res) => {
          toast.error(res?.message);
        }
      )
    );
  };

  const handleDuplicate = (data) => {
    Swal.fire({
      title: `Are you sure you want to duplicate this development?`,
      icon: "question",
      confirmButtonText: "Yes",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "No",
      focusConfirm: false,
      confirmButtonColor: "#5a8dee",
      buttonsStyling: {},
    }).then((result) => {
      if (result.isConfirmed) {
        let toastId = toast.loading("Duplicating Development...");
        dispatch(
          duplicateDevelopment(
            data?._id,
            (res) => {
              toast.dismiss(toastId);
              toast.success("Development Duplicated!");
              navigate(`/development/edit/${res?.data?.slug}`);
            },
            (err) => {
              toast.dismiss(toastId);
              toast?.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleBulkAction = (type) => {
    if (type === "archive") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Archive",
      }).then((result) => {
        if (result.isConfirmed) {
          handleArchiveMultiple(
            () => {
              Swal.fire("Archived!", "Selected Developments has been archived.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (type === "delete") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDeleteMultiple(
            () => {
              Swal.fire("Deleted!", "Selected Developments has been deleted.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (type === "restore") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Restore",
      }).then((result) => {
        if (result.isConfirmed) {
          handleRestoreMultiple(
            () => {
              Swal.fire("Restored!", "Selected Developments has been restored.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    }
  };

  const handleArchiveMultiple = async (successCB, errorCB) => {
    dispatch(
      temperoryDeleteMultipleDevelopment(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            dispatch(
              getDevelopmentList({
                status: typeof status === "object" ? status?.value : status,
                saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                page: currentPage,
                limit: itemPerPage,
                search: onSearchText,
                sort,
                homeType: typeof homeType === "object" ? homeType?.value : "",
                city: typeof city === "object" ? city?.value : "",
                neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                developer: typeof developer === "object" ? developer?.value : "",
              })
            );
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleRestoreMultiple = async (successCB, errorCB) => {
    dispatch(
      restoreMultipleDevelopment(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            dispatch(
              getDevelopmentList({
                status: typeof status === "object" ? status?.value : status,
                saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                page: currentPage,
                limit: itemPerPage,
                search: onSearchText,
                sort,
                homeType: typeof homeType === "object" ? homeType?.value : "",
                city: typeof city === "object" ? city?.value : "",
                neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                developer: typeof developer === "object" ? developer?.value : "",
              })
            );
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleDeleteMultiple = async (successCB, errorCB) => {
    dispatch(
      permanentDeleteMultipleDevelopment(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            dispatch(
              getDevelopmentList({
                status: typeof status === "object" ? status?.value : status,
                saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                page: currentPage,
                limit: itemPerPage,
                search: onSearchText,
                sort,
                homeType: typeof homeType === "object" ? homeType?.value : "",
                city: typeof city === "object" ? city?.value : "",
                neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                developer: typeof developer === "object" ? developer?.value : "",
              })
            );
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleArchive = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Archive",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          temperoryDeleteDevelopment(
            item?._id,
            (res) => {
              if (res?.success) {
                dispatch(
                  getDevelopmentList({
                    status: typeof status === "object" ? status?.value : status,
                    saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                    page: currentPage,
                    limit: itemPerPage,
                    search: onSearchText,
                    sort,
                    homeType: typeof homeType === "object" ? homeType?.value : "",
                    city: typeof city === "object" ? city?.value : "",
                    neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                    developer: typeof developer === "object" ? developer?.value : "",
                  })
                );
              }
              Swal.fire("Archived!", "Development has been archived.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleRestore = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Restore",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          restoreDevelopment(
            item?._id,
            (res) => {
              if (res?.success) {
                dispatch(
                  getDevelopmentList({
                    status: typeof status === "object" ? status?.value : status,
                    saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                    page: currentPage,
                    limit: itemPerPage,
                    search: onSearchText,
                    sort,
                    homeType: typeof homeType === "object" ? homeType?.value : "",
                    city: typeof city === "object" ? city?.value : "",
                    neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                    developer: typeof developer === "object" ? developer?.value : "",
                  })
                );
              }
              Swal.fire("Archived!", "Development has been restored.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          permanentDeleteDevelopment(
            item?._id,
            (res) => {
              if (res?.success) {
                dispatch(
                  getDevelopmentList({
                    status: typeof status === "object" ? status?.value : status,
                    saleStatus: typeof saleStatus === "object" ? saleStatus?.value : saleStatus,
                    page: currentPage,
                    limit: itemPerPage,
                    search: onSearchText,
                    sort,
                    homeType: typeof homeType === "object" ? homeType?.value : "",
                    city: typeof homeType === "object" ? city?.value : "",
                    neighbourhood: typeof neighbourhood === "object" ? neighbourhood?.value : "",
                    developer: typeof developer === "object" ? developer?.value : "",
                  })
                );
              }
              Swal.fire("Deleted!", "Development has been deleted.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const markFeatured = (data) => {
    dispatch(handleAddDevelopment({ ...development?.addDevelopment, devStep: 8 }));
    navigate(`/development/edit/${data?.slug}`);
  };

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Developments"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Development</BlockTitle>
              <BlockDes className="text-soft">
                {development?.developments?.data?.length && development?.developments?.success ? (
                  <p>{development?.developments?.total?.total} developments.</p>
                ) : null}
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>

                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle btn-icon d-md-none"
                        onClick={() => {
                          dispatch(handleDevAddReset());
                          navigate("/development/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                      </Button>

                      <Button
                        className="toggle d-none btn-outline-primary btn-dim d-md-inline-flex"
                        onClick={() => {
                          dispatch(handleDevAddReset());
                          navigate("/development/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Development</span>
                      </Button>
                    </li>

                    {(typeof status === "object" && status?.value === "archive") || status === "archive" ? (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon btn-outline-info d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-info btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                          <span>All Developments</span>
                        </Button>
                      </li>
                    ) : (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-danger btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                          <span>Archived</span>
                        </Button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <Row className="">
                <Col sm={"12"} md={"12"} lg={"6"} className="card-tools">
                  <Row>
                    <Col sm={"12"} md={"6"} lg={"4"}>
                      <div className="">
                        <RSelect
                          options={
                            cityData?.cities?.data?.length
                              ? [
                                  { label: "All Cities", value: "" },
                                  ...cityData?.cities?.data?.map((item) => ({ value: item?._id, label: item?.name })),
                                ]
                              : []
                          }
                          isClearable
                          placeholder="City"
                          onChange={(e) => setCity(e)}
                          value={city}
                        />
                      </div>
                    </Col>
                    <Col sm={"12"} md={"6"} lg={"4"}>
                      <div className="">
                        <RSelect
                          options={
                            neighbourhoodData?.neighbourhoodByCity?.data?.length
                              ? [
                                  { label: "All Neighbourhoods", value: "" },
                                  ...neighbourhoodData?.neighbourhoodByCity?.data?.map((item) => ({
                                    value: item?._id,
                                    label: item?.name,
                                  })),
                                ]
                              : neighbourhoodData?.neighbourhoods?.data?.length
                              ? [
                                  { label: "All Neighbourhoods", value: "" },
                                  ...neighbourhoodData?.neighbourhoods?.data?.map((item) => ({
                                    value: item?._id,
                                    label: item?.name,
                                  })),
                                ]
                              : []
                          }
                          isClearable
                          placeholder="Neighbourhood"
                          onChange={(e) => setNeighbourhood(e)}
                          value={neighbourhood}
                        />
                      </div>
                    </Col>
                    <Col sm={"12"} md={"6"} lg={"4"}>
                      {/* <div className="">
                        <RSelect
                          options={
                            (typeof status === "object" && status?.value === "archive") || status === "archive"
                              ? bulkRestoreOptions
                              : bulkActionOptions
                            }
                            // className="w-130px"
                            isClearable
                            placeholder="Developer"
                            onChange={(e) => setDeveloper(e)}
                            value={developer}
                        />
                      </div> */}
                    </Col>
                  </Row>
                </Col>
                <Col sm={"12"} md={"12"} lg={"6"} className={"card-tools mr-n1"}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <ul className="btn-toolbar gx-1">
                      {/* Search */}
                      <li>
                        <div
                          className="search-content"
                          style={{
                            border: "1px solid #dbdfea",
                            borderRadius: "4px",
                          }}
                        >
                          <Button
                            className="search-back btn-icon toggle-search active"
                            onClick={() => {
                              setSearchText("");
                              toggle();
                            }}
                          >
                            <Icon name="search"></Icon>
                          </Button>
                          <input
                            type="text"
                            className="border-transparent form-focus-none form-control"
                            placeholder="Name, City, Neighbourhood, or Address"
                            value={onSearchText}
                            onChange={(e) => onFilterChange(e)}
                          />
                          {onSearchText ? (
                            <Button
                              className="search-submit btn-icon"
                              onClick={() => {
                                setSearchText("");
                              }}
                            >
                              <Icon name="cross"></Icon>
                            </Button>
                          ) : null}
                        </div>
                      </li>
                      <li className="btn-toolbar-sep"></li>
                      <li>
                        <div className="toggle-wrap">
                          <Button
                            className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                            onClick={() => updateTableSm(true)}
                          >
                            <Icon name="menu-right"></Icon>
                          </Button>
                          <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                            <ul className="btn-toolbar gx-1">
                              <li className="toggle-close">
                                <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                  <Icon name="arrow-left"></Icon>
                                </Button>
                              </li>
                              {/* Filter */}
                              <li>
                                <UncontrolledDropdown>
                                  <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                    <Icon name="filter-fill"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu
                                    right
                                    className="filter-wg dropdown-menu-xl"
                                    style={{ overflow: "visible" }}
                                  >
                                    <div className="dropdown-head">
                                      <span className="sub-title dropdown-title">Filter Developments</span>
                                    </div>
                                    <div className="dropdown-body dropdown-body-rg">
                                      <Row className="gx-6 gy-3">
                                        <Col size="6">
                                          <FormGroup>
                                            <label className="overline-title overline-title-alt">Status</label>
                                            <RSelect
                                              options={statusOptions}
                                              onChange={(value) => {
                                                setStatus(value);
                                              }}
                                              value={status}
                                              placeholder="Select"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col size="6">
                                          <FormGroup>
                                            <label className="overline-title overline-title-alt">Sale Status</label>
                                            <RSelect
                                              options={saleStatusData?.saleStatus?.map((item) => ({
                                                value: item?._id,
                                                label: item?.name,
                                              }))}
                                              onChange={(value) => {
                                                setSaleStatus(value);
                                              }}
                                              value={saleStatus}
                                              placeholder="Select"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col size="6">
                                          <FormGroup>
                                            <label className="overline-title overline-title-alt">Items Per Page</label>
                                            <RSelect
                                              options={itemsPerPageOptions}
                                              onChange={(value) => {
                                                setLimit(value);
                                              }}
                                              value={limit}
                                              placeholder="Select"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div className="dropdown-foot between">
                                      <span></span>
                                      <a
                                        href="#reset"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setStatus("");
                                          setSaleStatus("");
                                        }}
                                        className="clickable"
                                      >
                                        Reset Filter
                                      </a>
                                    </div>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                              {/* Sort */}
                              <li>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    color="tranparent"
                                    className="btn btn-trigger btn-icon dropdown-toggle"
                                  >
                                    <Icon name="sort-line"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <ul className="link-list-opt no-bdr">
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdownitem"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            setSort("recently-updated");
                                          }}
                                          className={sort === "recently-updated" ? "text text-primary" : ""}
                                        >
                                          <span>Recently Updated</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdownitem"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            setSort("recently-added");
                                          }}
                                          className={sort === "recently-added" ? "text text-primary" : ""}
                                        >
                                          <span>Recently Added</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdownitem"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            setSort("oldest");
                                          }}
                                          className={sort === "oldest" ? "text text-primary" : ""}
                                        >
                                          <span>Oldest First</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdownitem"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            setSort("asc");
                                          }}
                                          className={sort === "asc" ? "text text-primary" : ""}
                                        >
                                          <span>0-9, A-Z</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdownitem"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            setSort("desc");
                                          }}
                                          className={sort === "desc" ? "text text-primary" : ""}
                                        >
                                          <span>9-0, Z-A</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <div className={`card-search search-wrap `}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {development?.developments?.loading ? (
              <div
                style={{
                  height: "200px",
                  width: "100%",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Spinner type="grow" color="dark" />
              </div>
            ) : development?.developments?.success && development?.developments?.data?.length ? (
              <DataTableBody>
                <DataTableHead>
                  <DataTableRow className="nk-tb-col-check" align={"center"}>
                    <div className="custom-control custom-control-sm custom-checkbox notext">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        id="uid_1"
                        checked={development?.developments?.data
                          ?.map((item) => item._id)
                          .every((item) => selectedData.includes(item))}
                        onChange={(e) => selectorCheck(e)}
                      />
                      <label className="custom-control-label" htmlFor="uid_1"></label>
                    </div>
                  </DataTableRow>
                  <DataTableRow>
                    <span
                      onClick={() => {
                        setSort(sort === "asc" ? "desc" : sort === "desc" ? "asc" : "desc");
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Name
                      <Icon name={sort === "asc" ? "sort-up-fill" : sort === "desc" ? "sort-down-fill" : "sort-v"} />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      // onClick={() => {
                      //   setSort(
                      //     sort === "feature-asc"
                      //       ? "feature-desc"
                      //       : sort === "feature-desc"
                      //       ? "feature-asc"
                      //       : "feature-desc"
                      //   );
                      // }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Featured
                      {/* <Icon
                        name={
                          sort === "feature-asc"
                            ? "sort-up-fill"
                            : sort === "feature-desc"
                            ? "sort-down-fill"
                            : "sort-v"
                        }
                      /> */}
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(sort === "dom-asc" ? "dom-desc" : sort === "dom-desc" ? "dom-asc" : "dom-desc");
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      DOM
                      <Icon
                        name={sort === "dom-asc" ? "sort-up-fill" : sort === "dom-desc" ? "sort-down-fill" : "sort-v"}
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>
                      {(typeof status === "object" && status?.value === "archive") || status === "archive" ? (
                        "Status"
                      ) : (
                        <RSelect
                          options={statusOptions}
                          onChange={(value) => setStatus(value)}
                          isClearable
                          value={status}
                          placeholder="Status"
                          components={{ IndicatorSeparator: () => null }}
                        />
                      )}
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>
                      <RSelect
                        options={saleStatusData?.saleStatus?.map((item) => ({ value: item?._id, label: item?.name }))}
                        isClearable
                        components={{ IndicatorSeparator: () => null }}
                        placeholder="Sale St"
                        onChange={(e) => setSaleStatus(e)}
                        value={saleStatus}
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow>
                    <span style={{ fontSize: "16px", color: "#5d5d5d", fontWeight: "600" }}>
                      <RSelect
                        options={homeTypeData?.homeType?.map((item) => ({ value: item?._id, label: item?.name }))}
                        isClearable
                        components={{ IndicatorSeparator: () => null }}
                        placeholder="Type"
                        onChange={(e) => setHomeType(e)}
                        value={homeType}
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(
                          sort === "price-asc" ? "price-desc" : sort === "price-desc" ? "price-asc" : "price-desc"
                        );
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Price
                      <Icon
                        name={
                          sort === "price-asc" ? "sort-up-fill" : sort === "price-desc" ? "sort-down-fill" : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(
                          sort === "price-sqft-asc"
                            ? "price-sqft-desc"
                            : sort === "price-sqft-desc"
                            ? "price-sqft-asc"
                            : "price-sqft-desc"
                        );
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Price/sqft
                      <Icon
                        name={
                          sort === "price-sqft-asc"
                            ? "sort-up-fill"
                            : sort === "price-sqft-desc"
                            ? "sort-down-fill"
                            : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(sort === "recently-added" ? "oldest" : sort === "oldest" ? "recently-added" : "oldest");
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Created on
                      <Icon
                        name={
                          sort === "recently-added" ? "sort-up-fill" : sort === "oldest" ? "sort-down-fill" : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(
                          sort === "recently-updated"
                            ? "oldest-updated"
                            : sort === "oldest-updated"
                            ? "recently-updated"
                            : "oldest-updated"
                        );
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Updated On
                      <Icon
                        name={
                          sort === "recently-updated"
                            ? "sort-up-fill"
                            : sort === "oldest-updated"
                            ? "sort-down-fill"
                            : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow align={"center"}>
                    <span
                      onClick={() => {
                        setSort(
                          sort === "views-asc" ? "views-desc" : sort === "views-desc" ? "views-asc" : "views-desc"
                        );
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Views
                      <Icon
                        name={
                          sort === "views-asc" ? "sort-up-fill" : sort === "views-desc" ? "sort-down-fill" : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <ul className="nk-tb-actions gx-1 my-n1">
                      <li className="mr-n1">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            href="#toggle"
                            onClick={(ev) => ev.preventDefault()}
                            className="dropdown-toggle btn btn-icon btn-trigger"
                          >
                            <Icon name="more-h"></Icon>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <ul className="link-list-opt no-bdr">
                              {(typeof status === "object" && status?.value === "archive") || status === "archive" ? (
                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#edit"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      handleBulkAction("restore");
                                    }}
                                    disabled={permission && !permission?.edit}
                                  >
                                    <LuArchiveRestore
                                      style={{
                                        fontSize: "18px",
                                        marginRight: "15px",
                                        color: "#526484",
                                      }}
                                    />
                                    <span>Restore Selected</span>
                                  </DropdownItem>
                                </li>
                              ) : (
                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#edit"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      handleBulkAction("archive");
                                    }}
                                    disabled={permission && !permission?.archive}
                                  >
                                    <Icon name="archived-fill"></Icon>
                                    <span>Archive Selected</span>
                                  </DropdownItem>
                                </li>
                              )}
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#remove"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    handleBulkAction("delete");
                                  }}
                                  disabled={permission && !permission?.delete}
                                >
                                  <Icon name="trash"></Icon>
                                  <span>Delete Selected Permanently</span>
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </DataTableRow>
                </DataTableHead>
                {development?.developments?.data?.length
                  ? development?.developments?.data?.map((item) => {
                      return (
                        <DataTableItem key={item._id}>
                          <DataTableRow className="nk-tb-col-check" align={"center"}>
                            <div className="custom-control custom-control-sm custom-checkbox notext">
                              <input
                                type="checkbox"
                                className="custom-control-input form-control"
                                id={item._id + "uid1"}
                                key={Math.random()}
                                checked={selectedData.includes(item._id)}
                                onChange={(e) => onSelectChange(e, item._id)}
                              />
                              <label className="custom-control-label" htmlFor={item._id + "uid1"}></label>
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            <div className="tb-product lazy-image">
                              <LazyLoadImage
                                src={
                                  item?.images?.length
                                    ? `${process.env.REACT_APP_IMGURL}${item.images?.[0]}`
                                    : PlaceholderImg
                                }
                                alt="development_image"
                                effect="blur"
                                className="thumb"
                                placeholderSrc={PlaceholderImg}
                                style={{ width: "70px", height: "45px", borderRadius: "4px", objectFit: "cover" }}
                              />
                              <div style={{ display: "flex", flexDirection: "column", fontSize: "12px" }}>
                                <div
                                  className="title"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px",
                                    padding: "0",
                                    margin: "0",
                                  }}
                                >
                                  <span>{item?.name}</span>
                                  <MdInfoOutline
                                    style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px", cursor: "pointer" }}
                                  />
                                  <a
                                    href={`${process.env.REACT_APP_USER_WEB_URL}development/${item?.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <ImNewTab style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px" }} />
                                  </a>
                                </div>
                                <span style={{}} className="sub-title">
                                  {item?.address?.firstLine}
                                </span>
                                <span style={{}} className="sub-title">
                                  {item?.address?.neighbourhood?.name}
                                </span>
                                <span style={{}} className="sub-title">
                                  {item?.company?.company?.[0]?.name} | {item?.construction?.constructionEnd?.year}
                                </span>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            {item?.featured === "Yes" ? (
                              <Button disabled color={"info"}>
                                Featured
                              </Button>
                            ) : (
                              <Button
                                className={"toggle d-none btn-outline-info d-md-inline-flex"}
                                onClick={() => {
                                  markFeatured(item);
                                }}
                              >
                                Feature This
                              </Button>
                            )}
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">
                              {item?.publishDate
                                ? moment(Date.now()).diff(moment(item?.publishDate), "days") >= 1
                                  ? moment(Date.now()).diff(moment(item?.publishDate), "days")
                                  : 1
                                : ""}
                            </span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <p
                              className="tb-sub"
                              style={{
                                color: item?.isDeleted
                                  ? "#FF2A04"
                                  : item?.status === "active"
                                  ? "#00E200"
                                  : item?.status === "sold"
                                  ? "#FF2A04"
                                  : item?.status === "pending"
                                  ? "#FFAF3D"
                                  : item?.status === "draft"
                                  ? "#7B8089"
                                  : item?.status === "on hold"
                                  ? "#285766"
                                  : "",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0",
                                padding: "0",
                                margin: "0",
                                textTransform: "capitalize",
                              }}
                            >
                              <span>{item?.isDeleted ? "Archived" : item?.status}</span>
                            </p>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <p
                              style={{
                                color:
                                  item?.saleStatus?.saleStatus?.name === "Selling"
                                    ? "#00E200"
                                    : item?.saleStatus?.saleStatus?.name === "Sold Out"
                                    ? "#FF2A04"
                                    : item?.saleStatus?.saleStatus?.name === "Pending"
                                    ? "#FFAF3D"
                                    : item?.saleStatus?.saleStatus?.name === "Registration"
                                    ? "#7B8089"
                                    : item?.saleStatus?.saleStatus?.name === "On Hold"
                                    ? "#285766"
                                    : "",
                                display: "flex",
                                alignItems: "center",
                                gap: "0",
                                padding: "0",
                                margin: "0",
                              }}
                            >
                              <Icon name={"dot"} style={{ fontSize: "22px" }} />
                              <span style={{ padding: "0", margin: "0" }}>{item?.saleStatus?.saleStatus?.name}</span>
                            </p>
                          </DataTableRow>
                          <DataTableRow>
                            <div
                              className="tb-sub"
                              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                              <ul style={{ listStyle: "disc" }}>
                                {item?.homeTypes?.map((li, i) => (
                                  <li key={i}>{li?.name}</li>
                                ))}
                              </ul>
                            </div>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">
                              {item?.price?.price?.from &&
                              item?.price?.price?.to &&
                              item?.price?.price?.from === item?.price?.price?.to
                                ? USDollar(item?.price?.price?.from)
                                : item?.price?.price?.from &&
                                  item?.price?.price?.to &&
                                  item?.price?.price?.from !== item?.price?.price?.to
                                ? `${USDollar(item?.price?.price?.from)} - ${USDollar(item?.price?.price?.to)}`
                                : item?.price?.price?.from
                                ? USDollar(item?.price?.price?.from)
                                : ""}
                            </span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">
                              {item?.price?.pricePerSqft?.from &&
                              item?.price?.pricePerSqft?.to &&
                              item?.price?.pricePerSqft?.from === item?.price?.pricePerSqft?.to
                                ? USDollar(item?.price?.pricePerSqft?.from)
                                : item?.price?.pricePerSqft?.from &&
                                  item?.price?.pricePerSqft?.to &&
                                  item?.price?.pricePerSqft?.from !== item?.price?.pricePerSqft?.to
                                ? `${USDollar(item?.price?.pricePerSqft?.from)} - ${USDollar(
                                    item?.price?.pricePerSqft?.to
                                  )}`
                                : item?.price?.pricePerSqft?.from
                                ? USDollar(item?.price?.pricePerSqft?.from)
                                : ""}
                            </span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{moment(item?.createdAt).format("DD/MM/YYYY")}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{moment(item?.updatedAt).format("DD/MM/YYYY")}</span>
                          </DataTableRow>
                          <DataTableRow align={"center"}>
                            <span className="tb-sub">{item?.views}</span>
                          </DataTableRow>
                          <DataTableRow className="nk-tb-col-tools">
                            <ul className="nk-tb-actions gx-1 my-n1">
                              <li className="mr-n1">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    href="#more"
                                    onClick={(ev) => ev.preventDefault()}
                                    className="dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <ul className="link-list-opt no-bdr">
                                      {(typeof status === "object" && status?.value === "archive") ||
                                      status === "archive" ? (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#view"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleRestore(item);
                                            }}
                                            disabled={permission && !permission?.edit}
                                          >
                                            <LuArchiveRestore
                                              style={{ fontSize: "18px", marginRight: "15px", color: "#526484" }}
                                            />
                                            <span>Restore</span>
                                          </DropdownItem>
                                        </li>
                                      ) : (
                                        <>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#edit"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                dispatch(handleDevAddReset());
                                                navigate(`/development/edit/${item?.slug}`);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="edit"></Icon>
                                              <span>Edit this Development</span>
                                            </DropdownItem>
                                          </li>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleActiveDevelopment(item);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="eye"></Icon>
                                              <span>
                                                {item?.status === "active" ? "Put On Hold" : "Make It Active"}
                                              </span>
                                            </DropdownItem>
                                          </li>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleArchive(item);
                                              }}
                                              disabled={permission && !permission?.archive}
                                            >
                                              <Icon name="archived-fill"></Icon>
                                              <span>Archive</span>
                                            </DropdownItem>
                                          </li>
                                        </>
                                      )}
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#view"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            handleDelete(item);
                                          }}
                                          disabled={permission && !permission?.delete}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete Permanently</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                  : null}
              </DataTableBody>
            ) : development?.developments?.success && !development?.developments?.data?.length ? (
              <div
                className="text-center"
                style={{
                  padding: "20px",
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
              >
                <span className="text-silent">No Developments found</span>
              </div>
            ) : development?.developments?.error ? (
              <ErrorComponent error={development?.developments?.error} />
            ) : null}
            <div className="card-inner p-0">
              {development?.developments?.success && development?.developments?.data?.length ? (
                <DotPagination
                  itemPerPage={development?.developments?.total?.items_per_page}
                  totalItems={development?.developments?.total?.total}
                  paginate={paginate}
                  currentPage={currentPage}
                  siblingCount={2}
                  screenWidth={screenWidth}
                />
              ) : null}
            </div>
          </DataTable>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default Development;
